
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export interface CreditTransaction {
  id: string;
  type: 'purchase' | 'usage';
  amount: number;
  description: string;
  date: string;
}

export const useTransactions = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["transactions", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("credit_transactions")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      
      // Transform the data to match the expected format
      return data.map(transaction => ({
        id: transaction.id,
        type: transaction.type as 'purchase' | 'usage',
        amount: transaction.amount,
        description: transaction.description,
        date: transaction.created_at // Map created_at to date
      }));
    },
    enabled: !!user,
  });
};
